var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPriceBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 5C9.55228 5 10 4.55228 10 4C10 3.44772 9.55228 3 9 3C8.44772 3 8 3.44772 8 4C8 4.55228 8.44772 5 9 5Z",
    stroke: "#6B6F7B",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.62501C12 1.27975 11.7203 1 11.375 1C11.336 1 7.65602 1.0005 7.65602 1.0005C7.32353 1.0005 7.00528 0.983 6.82078 1.1675L1.13856 6.84957C0.953813 7.03407 0.953813 7.33357 1.13856 7.51807L5.48204 11.8616C5.66654 12.0461 5.96603 12.0461 6.15053 11.8616L11.8325 6.17931C12.017 5.99506 11.9995 5.6843 11.9995 5.3443C11.9995 5.3443 12 1.66401 12 1.62501Z",
    stroke: "#6B6F7B",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceBadge);
export default __webpack_public_path__ + "static/media/priceBadge.0975206af9dda2773e1c3dcf21e693ee.svg";
export { ForwardRef as ReactComponent };